import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { gridSize } from "../Calendar/index.mjs.mjs";
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-1oci48s" }) `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${gridSize * 7}px;
`;
export const StyledHeaderContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledHeaderContainer", componentId: "auir-611444a-1w2khwn" }) `
  width: ${gridSize * 7}px;
`;
export const StyledBodyContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledBodyContainer", componentId: "auir-611444a-mmoc12" }) `
  display: flex;
  flex-direction: column;
  width: ${gridSize * 7}px;
  min-height: ${gridSize * 6}px;
`;
//# sourceMappingURL=SingleCalendar.styles.mjs.mjs.map